export const isMobileSize = () => window.innerWidth < 768;
